import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { VaccinationComponent } from './vaccination.component';
import { VaccinationRoutingModule} from './vaccination.routing';
import { SharedModule } from '../../shared/shared.module';
import { MatInputModule, MatCheckboxModule  } from '@angular/material';

@NgModule({
    declarations:
    [
        VaccinationComponent       
    ],
    imports: [VaccinationRoutingModule, SharedModule, ReactiveFormsModule, 
        FormsModule, CommonModule,MatInputModule,MatCheckboxModule],
    providers: [],
 
    bootstrap: []
})

export class VaccinationModule {}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/view-schedule/vaccination.module.ts